"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStore = createStore;
const Sentry = __importStar(require("@sentry/browser"));
const Redux = __importStar(require("redux"));
const redux_saga_1 = __importDefault(require("redux-saga"));
const saga_1 = require("./saga");
const GlobalActions = __importStar(require("@genesys/client-core/lib/global-actions"));
const RavenActionBreadcrumbMiddleware = __importStar(require("@genesys/client-core/lib/raven-action-breadcrumb-middleware"));
const reducer_1 = require("./reducer");
const redux_logger_1 = require("redux-logger");
function createStore(clientConfig) {
    const sagaMiddleware = (0, redux_saga_1.default)();
    let actionLogger = clientConfig.environment === "localhost"
        ? [(0, redux_logger_1.createLogger)({ collapsed: true })]
        : [];
    // Support redux devtools browser extension.
    const compose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || Redux.compose;
    const storeEnhancers = compose(Redux.applyMiddleware(sagaMiddleware, RavenActionBreadcrumbMiddleware.createRavenActionBreadcrumbMiddleware(), ...actionLogger));
    const rootReducer = (0, reducer_1.createRootReducer)();
    const store = Redux.createStore(rootReducer, storeEnhancers);
    // Run main saga
    let rootTask = sagaMiddleware.run(saga_1.rootSaga);
    rootTask.done.catch((e) => {
        reportException(store.dispatch, e);
    });
    return store;
}
function reportException(dispatch, e) {
    Sentry.captureException(e);
    dispatch(GlobalActions.error({
        referenceNo: "",
        message: e.message,
        exception: e.stack,
        invalidState: true
    }));
}
//# sourceMappingURL=store.js.map